import '@angular/common/locales/global/nl-BE'
import '@shoelace-style/shoelace/dist/components/tab-group/tab-group.js';
import '@shoelace-style/shoelace/dist/components/tab/tab.js';
import '@shoelace-style/shoelace/dist/components/tab-panel/tab-panel.js';

import {Component, OnDestroy, OnInit} from '@angular/core'
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IUser } from "redwood-model/dist"
import {findPoolByName, IPool, PARAMS, POOL_NAMES} from "../PARAMS";
import {showToast, TOAST_LEVELS} from "../../toast";
import {REDIRECT_URL_ON_STARTUP, USER_MAPPING_INFO_KEY} from "../../main";
import {reInitAmplify} from "../../utils";
import {graphqlRequest} from "../graphqlHelper";
import {getSession} from "../amplify/amplify";
import {logDebug, logError} from "../../log";
import {showSpinner} from "../../spinner";
import { logoutFromAmplifyState, tryGetTokenFromAmplifyState } from '../amplify/amplify_state';

@Component({
  selector: 'validate-add-user',
  templateUrl: './validate-user.component.html',
  styleUrls: ['./validate-user.component.scss']
})
export class ValidateUserComponent implements OnInit, OnDestroy {
  loginForm: FormGroup | undefined
  user: IUser | undefined
  userFound = false
  amplify_user: any
  destination_pool: IPool | undefined
  destination_id: string | undefined
  mappingInfo: any
  constructor(private formBuilder: FormBuilder) {
  }

  ngOnDestroy() {
  }

  async ngOnInit() {
    try {
      this.mappingInfo = JSON.parse(localStorage.getItem(USER_MAPPING_INFO_KEY) || '')
      this.destination_pool = findPoolByName(this.mappingInfo['pool'])
      this.destination_id = this.mappingInfo['destination_id']
      const principal = this.mappingInfo['userInfo']['email']

      let email
        if (principal) {
          email = await this.fetchExistingUser(principal)
        }
        if (!email) {
          const tabGroup = document.querySelector('sl-tab-group') as any;
          if (tabGroup) {
            tabGroup.show('create');
          }
        }
        this.userFound = !!email


      this.loginForm = this.formBuilder.group({
        principal: [email, Validators.required],
        password: [undefined, [Validators.required]],
      })
    }
    catch (err) {
      logError(err)
    }

  }
  get isValid(): boolean {
    return !!this.loginForm?.valid;
  }
  async onSubmit(event: SubmitEvent) {
    event.preventDefault()

    try {

      if (!this.isValid) {
        throw new Error('Uw login gegevens werden niet correct ingevuld!')
      }


      const {
        principal: usernameOrEmail,
        password
      } = this.loginForm?.value


      const query = `
      query verifyUserQuery($usernameOrEmail: String!, $password: String!) {
        verifyUserQuery(usernameOrEmail: $usernameOrEmail, password: $password) {
          id
        }
      }`
      const variables = { usernameOrEmail, password  };

      const operationName = 'verifyUserQuery'

      const {data, errors} = await graphqlRequest( {
        url: PARAMS["REDWOOD-LAMBDA"]+'/query',
        query,
        operationName,
        variables,
      })
      if (!data?.data['verifyUserQuery']) {
        throw new Error('De logincombinatie is niet gevonden in het systeem!')
      }
      const id = data.data['verifyUserQuery']['id']

      if (!errors.length && id) {
        showSpinner(`${usernameOrEmail} werd succesvol gekoppeld! U wordt nu uitgelogd.`)
        await this.finalizeMapping(usernameOrEmail)
      }
      if  (errors.length || !id)  {
        throw new Error('Er ging iets mis bij  het inloggen!')
      }

    }
    catch (err: any) {
      logError(err)
      showToast(err.message, TOAST_LEVELS.ERROR)
    }

  }
  async fetchExistingUser(principal: string): Promise<string|undefined> {
    let email = undefined

    try {
      const token = this.amplify_user?.signInUserSession?.accessToken?.jwtToken || (await getSession()).access_token

      const query = `
      query userByPrincipalQuery($principal: String!) {
            userByPrincipalQuery(principal: $principal) {
                email
            }
        }`
      const variables = { principal: principal };

      const operationName = 'userByPrincipalQuery'

      const {data, errors} = await graphqlRequest( {
        url: PARAMS["REDWOOD-LAMBDA"]+'/query',
        query,
        operationName,
        token,
        variables
      })

      email = data?.data?.userByPrincipalQuery?.email

      if (!email) {
        throw new Error(`user with ${principal} was not found`)
      }
      return email
    } catch (err) {
      logError(err)
    }
    finally {
      return email
    }
  }
  get poolName(): string {
    if (this.destination_pool?.DISPLAY_NAME) return this.destination_pool?.DISPLAY_NAME
    if (typeof this.destination_pool === 'string') return this.destination_pool

    return 'onbekend'
  }

  public async finalizeMapping(username: string) {
    try {
      const token = tryGetTokenFromAmplifyState(localStorage)
      if(!token) throw new Error('no token')

      switch (this.destination_pool?.NAME) {
        case POOL_NAMES.SMARTSCHOOL:
        case POOL_NAMES.TEST_SMARTSCHOOL: {
          const smartschool_id = this.destination_id
          const body = {
            smartschool_id,
            username
          }

          const strBody = JSON.stringify(body)

          if (!body.smartschool_id || !body.username) {
            throw new Error('body of Smartschool-lambda request is invalid!')

          }

          const response = await fetch(`${PARAMS.SMARTSCHOOL_LAMBDA}`, {
            method: "POST",
            headers: {
              'Authorization': `Bearer ${token}`
            },
            body: strBody
          })

          if (response.status !== 200) {
            throw new Error(response.statusText)
          }
          break
        }
        case POOL_NAMES.TEST_LEER_ID:
        case POOL_NAMES.LEER_ID: {
          const body = {
              leerid_id: this.destination_id,
              username: username
          }

          const strBody = JSON.stringify(body)
          const response = await fetch(`${PARAMS.LEERID_LAMBDA}`, {
              method: "POST",
              body: strBody,
              headers: {
                'Authorization': `Bearer ${token}`
              },
          })
          const result = await response.json()
          logDebug("result leerid lambda.", result)
          showSpinner("De leerid gebruiker zijn id wordt aan de corresponderende e-ducateme gebruiker gekoppeld.")
          break
        }
      }
      showSpinner(`Gebruiker ${username} werd succesvol gekoppeld! U wordt automatisch uitgelogd. Log dan opnieuw in.`)
      localStorage.removeItem(USER_MAPPING_INFO_KEY)
      logoutFromAmplifyState()
      setTimeout(() => {
        reInitAmplify(localStorage[REDIRECT_URL_ON_STARTUP])
      }, 2500) // so that the last msg can be read
    } catch (err) {
      showToast('Er liep iets mis, probeer later opnieuw', TOAST_LEVELS.ERROR)
      logError(err)
    }
  }
}

